import { toast } from '@/design-system/primitives/Toast';
import { setStoreNoticeReporter } from '@/shared/lib/store-notice';
import { setWriteFailureReporter } from '@/shared/lib/store-write';

/** Install browser presentation adapters for store failures and notices. */
export function configureStorePresentation(): void {
  setWriteFailureReporter((message) => toast.error(message));
  setStoreNoticeReporter(({ level, message, options }) => toast[level](message, options));
}
